import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-timezone" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex font-size-24 items-end" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mt-2" }, null, -1)
const _hoisted_5 = { class: "mt-8 w-50-custom" }
const _hoisted_6 = { class: "relative mt-1" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_8 = { class: "mt-6 w-50-custom relative" }
const _hoisted_9 = { class: "mt-6 input-text relative" }
const _hoisted_10 = { class: "mr-3" }
const _hoisted_11 = { class: "mt-6" }
const _hoisted_12 = { class: "align-top" }
const _hoisted_13 = { class: "select-wrap flex justify-around p-1" }
const _hoisted_14 = { class: "mr-2" }
const _hoisted_15 = { class: "align-top" }
const _hoisted_16 = { class: "justify-center flex flex-wrap p-1" }
const _hoisted_17 = { class: "flex res-box" }
const _hoisted_18 = { class: "w-24 mr-3 res-box-child" }
const _hoisted_19 = { class: "w-32 res-box-element flex" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "mr-6 ml-6 res-lg mt-3" }, "〜", -1)
const _hoisted_21 = { class: "flex res-box" }
const _hoisted_22 = { class: "w-24 mr-3 res-box-child" }
const _hoisted_23 = { class: "w-32 res-box-element flex" }
const _hoisted_24 = { class: "flex items-center justify-evenly" }
const _hoisted_25 = { class: "tooltiptext" }
const _hoisted_26 = { class: "tooltiptext" }
const _hoisted_27 = { class: "flex justify-center mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")
  const _component_Input = _resolveComponent("Input")
  const _component_Select = _resolveComponent("Select")
  const _component_InputTime = _resolveComponent("InputTime")
  const _component_my_table = _resolveComponent("my-table")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('basicSettings')), 1)
    ]),
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Label, {
          mandatory: "",
          "text-label": _ctx.t('timezoneCode')
        }, null, 8, ["text-label"]),
        _createVNode(_component_Input, {
          placeholder: _ctx.t('pleaseEnter'),
          modelValue: _ctx.paramsAddTimezoneSettings.time_zone_code,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.paramsAddTimezoneSettings.time_zone_code = $event)),
          errors: _ctx.errors.time_zone_code,
          "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors.time_zone_code = $event)),
          required: true,
          "error-server": _ctx.listErrorServerReturn.time_zone_code,
          validated: _ctx.validated
        }, null, 8, ["placeholder", "modelValue", "errors", "error-server", "validated"])
      ]),
      _hoisted_7
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_Label, {
        mandatory: "",
        "text-label": _ctx.t('timezoneName')
      }, null, 8, ["text-label"]),
      _createVNode(_component_Input, {
        placeholder: _ctx.t('pleaseEnter'),
        modelValue: _ctx.paramsAddTimezoneSettings.time_zone_name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.paramsAddTimezoneSettings.time_zone_name = $event)),
        errors: _ctx.errors.time_zone_name,
        "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors.time_zone_name = $event)),
        required: true,
        validated: _ctx.validated,
        "error-server": _ctx.listErrorServerReturn.time_zone_name
      }, null, 8, ["placeholder", "modelValue", "errors", "validated", "error-server"])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_Label, {
        mandatory: "",
        "text-label": _ctx.t('settingTargetDate')
      }, null, 8, ["text-label"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.optionTargetDate, (option) => {
        return (_openBlock(), _createBlock("label", {
          key: option.value,
          class: "inline-flex items-center mt-4"
        }, [
          _createVNode("input", {
            value: _ctx.paramsAddTimezoneSettings.setting_target_date,
            name: "applicationDate",
            type: "radio",
            class: "h-4 w-4 border-gray-300 mr-3 radio",
            checked: 
            option.value === _ctx.paramsAddTimezoneSettings.setting_target_date
          ,
            onChange: ($event: any) => (_ctx.onSelect(option.value))
          }, null, 40, ["value", "checked", "onChange"]),
          _createVNode("span", _hoisted_10, _toDisplayString('   ' + option.text), 1)
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_Label, {
        textLabel: _ctx.t('timezoneDetails'),
        hasHint: true
      }, null, 8, ["textLabel"])
    ]),
    (_openBlock(), _createBlock("div", {
      class: "mt-2",
      key: _ctx.count
    }, [
      _createVNode(_component_my_table, {
        class: "w-full",
        headers: _ctx.timezoneHeaders,
        data: _ctx.paramsAddTimezoneSettings.time_zone_details,
        visibleTable: ""
      }, {
        body: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paramsAddTimezoneSettings.time_zone_details, (item, index) => {
            return (_openBlock(), _createBlock("tr", {
              key: index,
              class: 'tr-timezone_detail_' + index
            }, [
              _createVNode("td", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    (_ctx.paramsAddTimezoneSettings.setting_target_date === 0)
                      ? (_openBlock(), _createBlock(_component_Select, {
                          key: 0,
                          modelValue: 
                      _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                        .week_or_month
                    ,
                          "onUpdate:modelValue": ($event: any) => (
                      _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                        .week_or_month
                     = $event),
                          class: "text-center",
                          "options-select": _ctx.weekOptions,
                          "item-value": "value",
                          "item-text": "text",
                          placeholder: _ctx.t('placeholderSelect'),
                          errors: 
                      _ctx.errors['time_zone_details.' + index + '.week']
                    ,
                          "onUpdate:errors": ($event: any) => (
                      _ctx.errors['time_zone_details.' + index + '.week']
                     = $event),
                          "error-server": 
                      _ctx.listErrorServerReturn[
                        'time_zone_details.' + index + '.week'
                      ]
                    ,
                          required: true,
                          validated: _ctx.validated
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options-select", "placeholder", "errors", "onUpdate:errors", "error-server", "validated"]))
                      : _createCommentVNode("", true),
                    (_ctx.paramsAddTimezoneSettings.setting_target_date === 1)
                      ? (_openBlock(), _createBlock(_component_Select, {
                          key: 1,
                          modelValue: 
                      _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                        .week_or_month
                    ,
                          "onUpdate:modelValue": ($event: any) => (
                      _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                        .week_or_month
                     = $event),
                          class: "text-center",
                          "options-select": _ctx.monthOptions,
                          "item-value": "value",
                          "item-text": "text",
                          placeholder: _ctx.t('placeholderSelect'),
                          errors: 
                      _ctx.errors['time_zone_details.' + index + '.month']
                    ,
                          "onUpdate:errors": ($event: any) => (
                      _ctx.errors['time_zone_details.' + index + '.month']
                     = $event),
                          "error-server": 
                      _ctx.listErrorServerReturn[
                        'time_zone_details.' + index + '.month'
                      ]
                    ,
                          required: true,
                          validated: _ctx.validated
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options-select", "placeholder", "errors", "onUpdate:errors", "error-server", "validated"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", null, [
                    (_ctx.paramsAddTimezoneSettings.setting_target_date === 0)
                      ? (_openBlock(), _createBlock(_component_Select, {
                          key: 0,
                          modelValue: 
                      _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                        .day_or_date
                    ,
                          "onUpdate:modelValue": ($event: any) => (
                      _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                        .day_or_date
                     = $event),
                          class: "text-center",
                          "options-select": _ctx.dayOptions,
                          errors: 
                      _ctx.errors['time_zone_details.' + index + '.day']
                    ,
                          "onUpdate:errors": ($event: any) => (
                      _ctx.errors['time_zone_details.' + index + '.day']
                     = $event),
                          "error-server": 
                      _ctx.listErrorServerReturn[
                        'time_zone_details.' + index + '.day'
                      ]
                    ,
                          "item-value": "value",
                          "item-text": "text",
                          placeholder: _ctx.t('placeholderSelect'),
                          required: true,
                          validated: _ctx.validated
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options-select", "errors", "onUpdate:errors", "error-server", "placeholder", "validated"]))
                      : _createCommentVNode("", true),
                    (_ctx.paramsAddTimezoneSettings.setting_target_date === 1)
                      ? (_openBlock(), _createBlock(_component_Select, {
                          key: 1,
                          modelValue: 
                      _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                        .day_or_date
                    ,
                          "onUpdate:modelValue": ($event: any) => (
                      _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                        .day_or_date
                     = $event),
                          class: "text-center",
                          "options-select": _ctx.dateOptions,
                          errors: 
                      _ctx.errors['time_zone_details.' + index + '.date']
                    ,
                          "onUpdate:errors": ($event: any) => (
                      _ctx.errors['time_zone_details.' + index + '.date']
                     = $event),
                          "error-server": 
                      _ctx.listErrorServerReturn[
                        'time_zone_details.' + index + '.date'
                      ]
                    ,
                          "item-value": "value",
                          "item-text": "text",
                          placeholder: _ctx.t('placeholderSelect'),
                          required: true,
                          validated: _ctx.validated
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options-select", "errors", "onUpdate:errors", "error-server", "placeholder", "validated"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("td", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode(_component_Select, {
                        modelValue: 
                        _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                          .time_zone_start_on_day
                      ,
                        "onUpdate:modelValue": ($event: any) => (
                        _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                          .time_zone_start_on_day
                       = $event),
                        class: "text-center",
                        "options-select": _ctx.optionsChoseTime,
                        "item-value": "value",
                        "item-text": "text",
                        required: true,
                        validated: _ctx.validated,
                        placeholder: _ctx.t('placeholderSelect'),
                        "error-server": 
                        _ctx.listErrorServerReturn[
                          'time_zone_details.' +
                            index +
                            '.time_zone_start_on_day'
                        ]
                      ,
                        errors: 
                        _ctx.errors[
                          'time_zone_details.' +
                            index +
                            '.time_zone_start_on_day'
                        ]
                      ,
                        "onUpdate:errors": ($event: any) => (
                        _ctx.errors[
                          'time_zone_details.' +
                            index +
                            '.time_zone_start_on_day'
                        ]
                       = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options-select", "validated", "placeholder", "error-server", "errors", "onUpdate:errors"])
                    ]),
                    _createVNode("div", _hoisted_19, [
                      _createVNode(_component_InputTime, {
                        modelValue: 
                        _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                          .time_zone_start
                      ,
                        "onUpdate:modelValue": ($event: any) => (
                        _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                          .time_zone_start
                       = $event),
                        "error-server": 
                        _ctx.listErrorServerReturn[`time_zone_start[${index}]`]
                      ,
                        validated: _ctx.validated,
                        required: true,
                        errors: 
                        _ctx.errors[
                          'time_zone_details.' + index + '.time_zone_start'
                        ]
                      ,
                        "onUpdate:errors": ($event: any) => (
                        _ctx.errors[
                          'time_zone_details.' + index + '.time_zone_start'
                        ]
                       = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "error-server", "validated", "errors", "onUpdate:errors"])
                    ])
                  ]),
                  _hoisted_20,
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode(_component_Select, {
                        modelValue: 
                        _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                          .time_zone_end_on_day
                      ,
                        "onUpdate:modelValue": ($event: any) => (
                        _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                          .time_zone_end_on_day
                       = $event),
                        class: "text-center",
                        "options-select": _ctx.optionsChoseTime,
                        "item-value": "value",
                        "item-text": "text",
                        placeholder: _ctx.t('placeholderSelect'),
                        validated: _ctx.validated,
                        required: true,
                        "error-server": 
                        _ctx.listErrorServerReturn[
                          'time_zone_details.' + index + '.time_zone_end_on_day'
                        ]
                      ,
                        errors: 
                        _ctx.errors[
                          'time_zone_details.' + index + '.time_zone_end_on_day'
                        ]
                      ,
                        "onUpdate:errors": ($event: any) => (
                        _ctx.errors[
                          'time_zone_details.' + index + '.time_zone_end_on_day'
                        ]
                       = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options-select", "placeholder", "validated", "error-server", "errors", "onUpdate:errors"])
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode(_component_InputTime, {
                        modelValue: 
                        _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                          .time_zone_end
                      ,
                        "onUpdate:modelValue": ($event: any) => (
                        _ctx.paramsAddTimezoneSettings.time_zone_details[index]
                          .time_zone_end
                       = $event),
                        "error-server": 
                        _ctx.listErrorServerReturn[`time_zone_end[${index}]`]
                      ,
                        validated: _ctx.validated,
                        required: true,
                        errors: 
                        _ctx.errors['time_zone_details.' + index + '.time_zone_end']
                      ,
                        "onUpdate:errors": ($event: any) => (
                        _ctx.errors['time_zone_details.' + index + '.time_zone_end']
                       = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "error-server", "validated", "errors", "onUpdate:errors"])
                    ])
                  ])
                ])
              ]),
              _createVNode("td", null, [
                _createVNode("div", _hoisted_24, [
                  _withDirectives(_createVNode("span", {
                    onClick: ($event: any) => (_ctx.removeTimezoneDetail(index)),
                    class: "cp-icon-minus-circle text-red-ff cursor-pointer text-3xl"
                  }, [
                    _createVNode("span", _hoisted_25, _toDisplayString(_ctx.t('actionDelete')), 1)
                  ], 8, ["onClick"]), [
                    [_vShow, 
                    _ctx.paramsAddTimezoneSettings.time_zone_details.length > 1
                  ]
                  ]),
                  _createVNode("span", {
                    onClick: ($event: any) => (
                    _ctx.addTimezoneDetail(
                      item,
                      _ctx.paramsAddTimezoneSettings.time_zone_details.length
                    )
                  ),
                    class: ["cp-icon-plus-circle text-3xl text-light-blue", [
                    _ctx.isDisableAdd(item)
                      ? 'pointer-events-none text-grey-999'
                      : 'cursor-pointer',
                    index ===
                    _ctx.paramsAddTimezoneSettings.time_zone_details.length - 1
                      ? ' opacity-100'
                      : 'pointer-events-none opacity-0',
                  ]]
                  }, [
                    _createVNode("span", _hoisted_26, _toDisplayString(_ctx.t('addAction')), 1)
                  ], 10, ["onClick"])
                ])
              ])
            ], 2))
          }), 128))
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ])),
    _createVNode("div", _hoisted_27, [
      _createVNode(_component_Button, {
        onClick: _ctx.submitCreateOrUpdateTimezoneDivisionSettings,
        class: "btn-gradation-light-blue w-50 h-12 mr-20"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('toRegister')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackToTheList,
        class: "btn-gradation-secondary w-50 h-12"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('backToTheList')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}